import React from "react";
import {
  Card,
  CardContent,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { useTranslate } from "react-admin";
import { DatePicker } from "@material-ui/pickers";
import { startOfDay } from "date-fns";
import { useFuelEconomyReport } from "../fuel-economy-report/FuelEconomyReportContext";

export const ReportDashboardPickers: React.FC = () => {
  const translate = useTranslate();
  const {
    dateFrom,
    dateTo,
    presetPeriod,
    setDateFrom,
    setDateTo,
    handlePeriodChange,
    setPresetPeriod,
  } = useFuelEconomyReport();

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item>
            <DatePicker
              label={translate("resources.reports.labels.fromDate", {
                _: "From Date",
              })}
              value={dateFrom}
              onChange={(value) => {
                if (value) setDateFrom(startOfDay(value));
              }}
              format="MMMM do yyyy"
              autoOk
            />
          </Grid>
          <Grid item>
            <DatePicker
              label={translate("resources.reports.labels.toDate", {
                _: "To Date",
              })}
              value={dateTo}
              onChange={(value) => {
                if (value) setDateTo(startOfDay(value));
              }}
              format="MMMM do yyyy"
              autoOk
            />
          </Grid>
          <Grid item>
            <FormControl variant="standard" style={{ minWidth: 150 }}>
              <InputLabel id="period-preset-label">
                {translate("resources.reports.labels.period", { _: "Period" })}
              </InputLabel>
              <Select
                value={presetPeriod}
                variant="standard"
                onChange={(e) => {
                  const value = e.target.value;
                  setPresetPeriod(value);
                  handlePeriodChange(value);
                }}
                label={translate("resources.reports.labels.period", {
                  _: "Period",
                })}
              >
                <MenuItem value="thisWeek">
                  {translate("resources.reports.labels.thisWeek", {
                    _: "This Week",
                  })}
                </MenuItem>
                <MenuItem value="lastWeek">
                  {translate("resources.reports.labels.lastWeek", {
                    _: "Last Week",
                  })}
                </MenuItem>
                <MenuItem value="thisMonth">
                  {translate("resources.reports.labels.thisMonth", {
                    _: "This Month",
                  })}
                </MenuItem>
                <MenuItem value="lastMonth">
                  {translate("resources.reports.labels.lastMonth", {
                    _: "Last Month",
                  })}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* <Grid item>
            <MuiButton
              variant="contained"
              color="primary"
              disabled={isDownloading}
              onClick={handleDownload}
            >
              {translate("resources.common.labels.download", { _: "Download" })}
            </MuiButton>
          </Grid> */}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ReportDashboardPickers;
